import { render } from "./Hello.vue?vue&type=template&id=2bb3fc23"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__